var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.categories),function(key){return _c('b-list-group-item',{key:key,staticClass:"d-none d-lg-block",attrs:{"href":`#${_vm.getFramaname(key) !== undefined
      ? _vm.$t(_vm.getFramaname(key), '-tlL').replace(/[^a-z]/g, '')
      : key}`}},[_c('i',{class:`${_vm.getSectionIcon(key)} fc-g6`}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.getFramaname(key) ? _vm.getFramaname(key) : _vm.$t(`faq.${key}.title`))}})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }